/** Jornada de trabalho: horários de meia em meia hora e dias da semana (puras). */

import { pad } from "./datas";

const MEIA_HORA = 30;
const HORARIOS_NO_DIA = 48;

export const HORARIOS_DE_MEIA_EM_MEIA = Array.from({ length: HORARIOS_NO_DIA }, (_, i) => {
  const minutos = i * MEIA_HORA;
  return `${pad(Math.floor(minutos / 60))}:${pad(minutos % 60)}`;
});

/** "1" = segunda … "7" = domingo, como o backend guarda `dias_uteis`. */
export const DIAS_DA_SEMANA = [["1", "seg"], ["2", "ter"], ["3", "qua"], ["4", "qui"], ["5", "sex"], ["6", "sáb"], ["7", "dom"]];

export function alternarDia(dias, dia) {
  const atual = new Set(String(dias || ""));
  if (atual.has(dia)) atual.delete(dia); else atual.add(dia);
  return [...atual].sort().join("");
}
